import React,{useState, useEffect} from 'react'
import { useFormContext } from '../../Context/FormContext';
import authqueries from '../../queries/authQueries';
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Spin, } from 'antd';

const Step3 = ({setCurrent, current, setCurrentTab, currentTab, navTab, setNavTab}) => {
    
    // const navigate = useNavigate()

    const [result, setResult] = useState([]);

    const [docData, setDocData] = useState("");

    const [vesselData, setVesselData] = useState("");

    const [err, setErr] = useState(false);

    const { formData, updateFormData } = useFormContext();

    const [loading, setLoading] = useState(false);


    const validationSchema = yup.object({
        port: yup
          .string()
          .required("⚠ Previous Port is required")
          .max(100,"⚠ Max length is 100"),
        vessel_id: yup
          .string()
          .required("⚠ Vessel is required"),
    });


    const { register, control, reset, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
    });


    useEffect(() => {
        setLoading(true)
        onSubmit();
        onDocSubmit();
        
    }, [vesselData]);

    useEffect(() => {
        if(formData?.vessel){
            setValue('vessel_id', formData?.vessel)
        }
    }, []);


    const VesselList  = authqueries.useVesselListMutation(
        (response) => {
            setLoading(false)
            console.log("RESPONSE",response?.data)
            const ascRes = response?.data.sort((a,b) => (a.name.localeCompare(b.name)))
            setResult(ascRes)
            VesselListings()

        } 
      );

      const VesselListings = () => {
        result.map((item) => {
            // console.log("LISTTTT >>>> ", `${item?.name} -  ${item?.vessel_imo}`)
            setVesselData(`${item?.name} -  ${item?.vessel_imo}`)
        })
      }
    
    const onSubmit = () =>{
        VesselList.mutateAsync({data : formData?.employer_code});
    };


    const DocList  = authqueries.useDocListMutation(
    (response) => {
        setLoading(false)
        setDocData(response?.DocHolder?.name +"  -  "+ response?.DocHolder?.imo)
    }
    );

    const onDocSubmit = () =>{
        DocList.mutateAsync({data : formData?.employer_code});
    };


    const SubmitData = async(data) => {

        // console.log("DATA ", data)

        await updateFormData({ doc_holder_id : `${DocList?.data?.DocHolder?.id}`, vessel_id : data?.vessel_id, previous_port: data?.port, vessel: vesselData})

        setErr(false)
        setNavTab(navTab + 1)
        setCurrent(current + 1)

        // console.log(JSON.stringify(formData))
            
    }


  return (

    <div>

        <Spin spinning={loading} size='large'>

            <div className="tab-pane" id="step3" role="tabpanel" aria-labelledby="nav-step3-tab">
                                
            {/* <div className="main-hding">Enter your Workplace Code provide by your employer</div> */}
        
                <div className="row">
            
                    <div className="col">
                        
                        <label>Employer Code</label>

                        <input type="text" disabled value={formData.employer_code} className="form-control" />

                    </div>

                    <div className="col">

                        <label>Doc Holder - <span style={{fontStyle: 'italic', fontSize:'11px'}}>Will be shared with your Employer</span></label>

                       

                        <input type="text"  disabled value={docData} className="form-control"  />

                    </div>
            
                </div>

                <div className="row mt-4">
            
                    <div className="col">

                        <label>Vessel Name<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span> </label>

                        <select 
                            onChange={(e) => console.log(e.target.value)} 
                            name='vessel_id' 
                            defaultValue={formData?.vessel_id}  
                            className="form-control" 
                            {...register('vessel_id')}
                        >

                            <option value="">Select</option>

                            {
                                result?.map((item, index) => (

                                    <option key={index} value={item?.id} >{`${item?.name} -  ${item?.vessel_imo}`}</option>
                                    
                            ))}
                
                        </select>

                        {

                            errors?.vessel_id  &&

                            <div className='err'>
                                {errors?.vessel_id?.message}
                            </div>

                            }

                    </div>

                    <div className="col">

                        <label>Previous Port<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>

                        <input maxLength={100} type="text" {...register('port')} defaultValue={formData?.previous_port} name='port' className="form-control"  />

                        {

                            errors?.port  &&

                            <div className='err'>
                                {errors?.port?.message}
                            </div>

                        }
            
                    </div>
            
                </div>

                {/* {JSON.stringify(formData)} */}

                <div className="row">

                    <div className='col-md-6'>

                        <div className="d-grid gap-2 mt-4 mb-4">
                
                            <button className="btn btn-primary btn-informant" 
                                type="submit" 
                                onClick={() => {
                                    setNavTab(navTab - 1)
                                    setCurrent(current - 1)
                                }}
                            >Back<i className="icon-arrow-left1"></i></button>

                        </div>

                    </div>

                    <div className='col-md-6'>

                        <div className="d-grid gap-2 mt-4 mb-4">
                
                            <button className="btn btn-primary btn-informant gotoStp4" type="submit" onClick={handleSubmit(SubmitData)}>Next <i className="icon-arrow-right1"></i></button>

                        </div>

                    </div>

                </div>
        
            </div>

        </Spin>

    </div>

  )
}

export default Step3